<template>
  <v-container fluid class="pa-8">
    <v-row align="center" justify="center">
      <v-col cols="12" class="mb-2">
        <home-current-page></home-current-page>
      </v-col>
      <v-col cols="12">
        <h2 class="title-page">Dados históricos da estimativa de chuva e vazão</h2>
        <h4 class="mt-2 subtitle-page">
          Use o formulário para consultar os dados históricos
        </h4>
      </v-col>
      <v-col cols="12">
        <rain-estimation-historical-summary-data
          :basins="processedListBasins"
          :searchResult="resultOfBasinData"
          :loadingOtherPeriod="loadingOtherPeriod"
          :loadingData="loadingData"
          @changeDataType="changeDataType($event)"
          @searchBasinData="searchData($event)"
          @applyPeriod="applyPeriod($event)"
        >
        </rain-estimation-historical-summary-data>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeCurrentPage from "../../components/common/HomeCurrentPage.vue";
import moment from "moment";
import RainEstimationHistoricalSummaryData from "../../components/common/RainEstimation/RainEstimationHistoricalSummaryData.vue";

export default {
  components: {
    HomeCurrentPage,
    RainEstimationHistoricalSummaryData,
  },
  data: () => ({
    processedListBasins: [],
    resultOfBasinData: undefined,
    loadingOtherPeriod: false,
    loadingData: false,
    location: undefined,
  }),

  created() {
    this.initialize();
  },

  computed: {
    locations() {
      return this.$store.getters.locations;
    },
    forecasts() {
      return this.$store.getters.forecasts;
    },
  },

  methods: {
    changeDataType(dataType){
      if(dataType){
        this.resultOfBasinData = undefined;
      }
    },
    async initialize() {
      this.resultOfBasinData = undefined;
      this.processedListBasins = this.createListBasinLocations(this.locations);
    },

    createListBasinLocations(locations) {
      const processedListBasins = [];
      for (const basin of locations) {
        const { locationname } = basin;
        processedListBasins.push(locationname);
      }
      return processedListBasins;
    },

    concatenateListIdsIntoString(list, keyName) {
      return list.reduce((before, current) => {
        const separateString = before ? "," : "";
        return `${before}${separateString}${current[keyName]}`;
      }, "");
    },
    basinFromProcessedBasinList(basin_ids, processedBasinsList) {
      return processedBasinsList.find((basin) => basin.codigo == basin);
    },

    async searchData(searchBasinDataParams) {
      this.loadingData = true;
      await this.searchBasinData(searchBasinDataParams);
      this.loadingData = false;
    },

    async searchBasinData(searchBasinDataParams) {
      const { location, dataType } = searchBasinDataParams;
      this.location = location
      if (dataType.value === "horario") {
        await this.$store.dispatch("loadHourlyForecast", {
          source: 26,
          location_id: location.locationid,
          final_date: dataType.date_end,
          initial_date: moment
            .tz(dataType.date_start, "America/Sao_Paulo")
            .subtract(1, "days")
            .utc()
            .format(),
          type: "hourly",
        });
        let result = await this.$store.getters.hourlyForecast;
        this.resultOfBasinData = {
          ...searchBasinDataParams,
          resultList: result,
          type: "horario",
          date_start: dataType.date_start,
          date_end: dataType.date_end,
        };
      }
      if (dataType.value === "diario") {
        await this.$store.dispatch("loadSiprecDailyEstimated", {
          startDate: dataType.date_start,
          endDate: dataType.date_end,
          locationId: location.locationid,
        });
        await this.$store.dispatch("loadPrevHidroDaily", {
          startDate: dataType.date_start,
          endDate: dataType.date_end,
          locationId: location.locationid,
        });
        let result = await this.$store.getters.siprecDailyEstimated;
        const flowForecasts = await this.$store.getters.prevHidroDaily;
        this.resultOfBasinData = {
          ...searchBasinDataParams,
          resultList: result,
          type: "diario",
          date_start: dataType.date_start,
          date_end: dataType.date_end,
          flowForecasts: flowForecasts,
        };
      }
      if (dataType.value === "mensal") {
        await this.$store.dispatch("loadMonthEstimated", {
          startDate: dataType.date_start,
          endDate: dataType.date_end,
          locationId: location.locationid,
        });
        await this.$store.dispatch("loadPrevHidroMonth", {
          startDate: dataType.date_start,
          endDate: dataType.date_end,
          locationId: location.locationid,
        });
        let result = await this.$store.getters.monthEstimated;
        const flowForecasts = await this.$store.getters.prevHidroMonth;
        this.resultOfBasinData = {
          ...searchBasinDataParams,
          resultList: result,
          type: "mensal",
          date_start: dataType.date_start,
          date_end: dataType.date_end,
          flowForecasts: flowForecasts,
        };
      }
    },

    async applyPeriod(periodSelected) {
      const { period } = periodSelected;
      const [date_start, date_end] = period;
      const { type } = this.resultOfBasinData;
      let dataType;
      if (type === "horario") {
        dataType = {
          date_start: moment.tz(date_start, "America/Sao_Paulo").utc().format(),
          date_end: moment.tz(date_end, "America/Sao_Paulo").utc().format(),
          value: type,
        };
      } else {
        dataType = { date_start, date_end, value: type };
      }
      this.loadingOtherPeriod = true;
      const location = this.location
      await this.searchBasinData({ location, dataType });
      this.loadingOtherPeriod = false;
    },
  },
};
</script>

<style scoped>
.title-page {
  /*width: 508px;*/
  height: 33px;
  left: 0px;
  top: 0px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
